'use client';

import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary] Section failed to render:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div
          className="w-full py-16 flex flex-col items-center justify-center gap-4"
          style={{ background: '#121212' }}
          role="alert"
          aria-live="polite"
        >
          <p className="font-dm-sans text-white/60 text-sm text-center px-4">
            Something went wrong loading this section. Please refresh the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="font-dm-sans text-xs font-semibold uppercase tracking-widest text-white border border-white/20 px-5 py-2.5 hover:border-white/50 transition-colors"
          >
            Refresh
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
